import { plan_api_get_plus_data_url } from 'mk/urls/functions';
import {
    getPlusFetchApi,
    GetPlusFetchNormalizedResponse,
    GetPlusFetchTriggerAction,
    GET_PLUS_FETCH_TRIGGER,
} from 'mk2/apps/plan/containers/GetPlus/GetPlus.actions';
import { PriceListItem } from 'mk2/apps/plan/schemas';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRGetError } from 'mk2/helpers/api';
import { removeEmpty } from 'mk2/helpers/urls';
import { getLogger } from 'mk2/logger';
import { UserEntity, UserSchema } from 'mk2/schemas';
import { normalize } from 'normalizr';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const logger = getLogger('plan/GetPlus.sagas');

interface ApiResponseFetch {
    body: {
        allowPayments: boolean;
        avatars: UserEntity[];
        bazaarPlusId: number;
        paymentVS: string;
        planIsActiveAndDisplaying: boolean;
        plusPrices: PriceListItem[];
    };
}

function* fetch({ src, xhr }: GetPlusFetchTriggerAction & XHRAction) {
    yield put(getPlusFetchApi.request(src));
    try {
        const response: ApiResponseFetch = yield call(() =>
        xhr.get(plan_api_get_plus_data_url(), removeEmpty({
            src,
        })));
        const normalizedResponse: GetPlusFetchNormalizedResponse = normalize(response.body, {
            avatars: [UserSchema],
        });

        yield put(getPlusFetchApi.success(normalizedResponse));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(getPlusFetchApi.failure(normalizeError(error)));
    }
}
export default function* root() {
    yield all([
        takeLatest(GET_PLUS_FETCH_TRIGGER, fetch),
    ]);
}
